import React, { useMemo } from "react";
import { AccordionDetails, Button, Stack } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { Iconify } from "@onair/minimal-ui/iconify";
import EventSessionNumberBadge from "../event-sessions/event-session-number-badge.tsx";
import TextMaxLine from "@onair/ui/text-max-line";
import {
	EventSessionAccordion,
	EventSessionAccordionSummary,
} from "../event-sessions/event-session-accordion";
import TicketTierForm from "../ticket-tiers";

interface PropTypes {
	index: number;
}

const EventSessionTicketTierBox: React.FC<PropTypes> = ({ index }) => {
	const { control, getFieldState } = useFormContext();

	const eventSessionName = useWatch({
		name: `stepTimeline.sessions.${index}.name`,
		control,
	});

	const { error } = getFieldState(`stepPricing.sessions.${index}.ticketTiers`);

	const isError = !!error;

	const header = useMemo(
		() => (
			<Stack
				direction={{
					xs: "column",
					md: "row",
				}}
				alignItems={{
					xs: "flex-start",
					md: "center",
				}}
				spacing={1}
			>
				<EventSessionNumberBadge number={index + 1} />
				<TextMaxLine
					line={1}
					variant="subtitle2"
					lineHeight="20px"
					fontWeight={600}
				>
					{eventSessionName || "Tên sự kiện"}
				</TextMaxLine>
			</Stack>
		),
		[eventSessionName, index],
	);

	return (
		<EventSessionAccordion>
			<EventSessionAccordionSummary
				// @ts-ignore
				isError={isError}
				expandIcon={
					<Button
						variant="soft"
						sx={{
							backgroundColor: "white",
							width: 34,
							minWidth: "unset",
						}}
					>
						<Iconify
							color="action.active"
							width={18}
							icon="eva:arrow-ios-downward-fill"
						/>
					</Button>
				}
			>
				<Stack
					width="100%"
					direction="row"
					justifyContent="space-between"
					alignItems={{
						xs: "flex-start",
						md: "center",
					}}
				>
					<Stack
						direction={{
							xs: "column",
							md: "row",
						}}
						alignItems={{
							xs: "flex-start",
							md: "end",
						}}
						justifyContent={{
							xs: "flex-start",
							md: "space-between",
						}}
						spacing={1}
					>
						{header}
					</Stack>
				</Stack>
			</EventSessionAccordionSummary>
			<AccordionDetails
				sx={{
					pt: {
						xs: 0,
						md: 2,
					},
				}}
			>
				<TicketTierForm
					prefixName={`stepPricing.sessions.${index}.ticketTiers`}
				/>
			</AccordionDetails>
		</EventSessionAccordion>
	);
};

export default EventSessionTicketTierBox;
